/* ==========================================================================
   Cueca Charmelle MEN, controle dos videos da LP
   --------------------------------------------------------------------------
   Mesma receita que a secao de midia do tema (a das calcinhas) usa:

   1. o mudo e ligado em javascript (video.muted = true mais o atributo),
      logo antes de mandar tocar. Se voce so deixar "muted" escrito no html,
      o iPhone ainda recusa o play automatico em varias situacoes.
   2. playsinline tambem ligado em javascript, pelo mesmo motivo.
   3. load() forcado, para o navegador escolher a fonte de verdade. Sem isso
      o iPhone as vezes fica em readyState 0, sem erro e sem imagem, que era
      exatamente o quadro branco que voce viu.
   4. so toca quando o video esta na tela (IntersectionObserver), e pausa
      quando sai. Nao pesa nem gasta dados do cliente a toa.
   5. quando a pessoa sai do navegador e volta, o video que esta na tela
      volta a tocar sozinho. Celular sempre congela video de aba escondida.

   Os videos do carrossel sao controlados pela propria secao, que chama
   window.cuecaVideo.tocar e .parar. Por isso eles sao ignorados no passo 4.
   ========================================================================== */

(function () {
  'use strict';

  function preparar(video) {
    if (!video || video.dataset.cuPronto === '1') return;
    video.dataset.cuPronto = '1';

    video.muted = true;
    video.setAttribute('muted', '');
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    if (video.readyState === 0) {
      try { video.load(); } catch (e) {}
    }
  }

  function tocar(video) {
    if (!video) return;
    preparar(video);
    var p = video.play();
    if (p && typeof p.catch === 'function') {
      p.catch(function () {
        // navegador recusou (modo de baixo consumo, por exemplo).
        // O poster continua na tela, com os controles para tocar na mao.
        video.controls = true;
      });
    }
  }

  function parar(video) {
    if (!video) return;
    try { video.pause(); } catch (e) {}
  }

  window.cuecaVideo = { preparar: preparar, tocar: tocar, parar: parar };

  function noCarrossel(el) {
    return !!(el.closest && el.closest('.cu-carrossel'));
  }

  function naTela(el) {
    var r = el.getBoundingClientRect();
    return r.bottom > 0 && r.top < (window.innerHeight || 0);
  }

  function ligar() {
    var videos = Array.prototype.slice.call(
      document.querySelectorAll('video.cu-midia__video')
    );

    videos.forEach(function (v) {
      v.playsInline = true;
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
    });

    var automaticos = videos.filter(function (v) {
      return v.hasAttribute('data-cu-auto') && !noCarrossel(v);
    });

    if (automaticos.length === 0) return;

    if (!('IntersectionObserver' in window)) {
      automaticos.forEach(tocar);
      return;
    }

    var olho = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) tocar(e.target);
        else parar(e.target);
      });
    }, { threshold: 0.25 });

    automaticos.forEach(function (v) { olho.observe(v); });
  }

  // capa do YouTube: troca pela moldura do player no primeiro toque
  function ligarFacades() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cu-facade]'), function (caixa) {
      if (caixa.dataset.cuPronto === '1') return;
      caixa.dataset.cuPronto = '1';

      caixa.addEventListener('click', function () {
        var molde = caixa.querySelector('[data-cu-iframe]');
        if (!molde) return;
        caixa.innerHTML = '';
        caixa.appendChild(molde.content.cloneNode(true));
        caixa.classList.remove('cu-midia__embed--facade');
      });
    });
  }

  // voltou para a aba: o que esta na tela volta a tocar.
  // No carrossel, so o quadro do meio.
  function aoVoltar() {
    if (document.hidden) return;
    Array.prototype.forEach.call(
      document.querySelectorAll('video[data-cu-auto]'),
      function (v) {
        var item = v.closest ? v.closest('.cu-carrossel__item') : null;
        if (item && !item.classList.contains('cu-esta-ativo')) return;
        if (naTela(v)) tocar(v);
      }
    );
  }

  function iniciar() {
    ligar();
    ligarFacades();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }

  document.addEventListener('visibilitychange', aoVoltar);
  window.addEventListener('pageshow', aoVoltar);

  // o editor da Shopify recarrega secoes sem recarregar a pagina
  document.addEventListener('shopify:section:load', iniciar);
})();
